import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';


class menu {
  constructor() {
    this.$burger = $('.burger');
    this.$menu = $('.mobile-menu');
    this.opened = false;

    this.init();
  }

  open() {
    if (!this.opened) {
      this.$burger.addClass('burger_open');
      this.$menu.addClass('mobile-menu_open');
      window.showOverlay();
      disableBodyScroll(this.$menu.get(0));
      this.opened = true;
    }
  }

  close() {
    if (this.opened) {
      this.$burger.removeClass('burger_open');
      this.$menu.removeClass('mobile-menu_open');
      window.hideOverlay();
      enableBodyScroll(this.$menu.get(0));
      this.opened = false;
    }
  }

  toggle() {
    if (!this.$menu.is(':animated')) {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  init() {
    this.$burger.get(0).onclick = (event) => {
      event.preventDefault();
      this.toggle();
    };

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });

    document.querySelector('.overlay').addEventListener('click', (event) => {
      event.preventDefault();
      this.close();
    });



  }

}

document.addEventListener('DOMContentLoaded', () => {
  new menu();
});
